import { createContext, useContext } from 'react'
import { isEmpty } from 'remeda'
import type { StaffPickIcon } from '@velasca/types'
import { handleError } from '@velasca/utils/handle-error'
import { parseJSONSafe } from '@velasca/utils/parse-json-safe'

interface StaffPickImageProviderProps {
  staffPickIcons: StaffPickIcon[]
  settings: {
    newID: string | null
  }
  children?: React.ReactNode
}

const StaffPickImageProviderContext =
  createContext<StaffPickImageProviderProps>({
    staffPickIcons: [],
    settings: {
      newID: null,
    },
  })

export const useStaffPickImage = () => useContext(StaffPickImageProviderContext)

const staffPickImagesEl = document.querySelector<HTMLElement>(
  '#staff-pick-images-json',
)
const staffPickImagesJson = staffPickImagesEl
  ? parseJSONSafe(staffPickImagesEl.innerText)
  : {}

const StaffPickImageProvider = ({
  children,
}: {
  children?: React.ReactNode
}) => {
  if (isEmpty(staffPickImagesJson.staffPickIcons)) {
    handleError(
      new Error(
        'StaffpickIconsProvider is initialized with empty staffPickIcons list',
      ),
    )
  }

  return (
    <StaffPickImageProviderContext.Provider value={staffPickImagesJson}>
      {children}
    </StaffPickImageProviderContext.Provider>
  )
}

export default StaffPickImageProvider
